import React, { FC } from 'react';
import { useModal } from 'store/modal';
import API from 'core/Api';
import Button from 'components/Button';
import TooltipWrapper from 'components/TooltipWrapper';
import { useTranslation } from 'react-i18next';
import { FaTrash } from 'react-icons/fa';
import { createErrorFromResponse } from 'core/Error';
import useInvalidateQueries from 'utils/helpers/useInvalidateQueries';

interface IProps {
  children?: any;
  id: string;
  buttonText: string;
  disabled: boolean;
  className?: string;
  invalidate: () => void;
  size?: 'sm' | 'lg';
}

const HardDeleteDoc: FC<IProps> = ({ id, buttonText, disabled, invalidate, className, size }: IProps) => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const invalidateQueries = useInvalidateQueries();

  // Delete document
  const handleDelete = (docId: string) =>
    API.delete(`health-and-safety-training/${docId}`)
      .then(() => {
        showModal({
          type: 'success',
          content: t('healthAndSafetyTraining.deletedSuccessMsg'),
        });
        invalidateQueries([], invalidate);
      })
      .catch(err =>
        showModal({
          type: 'error',
          content: createErrorFromResponse(err).message,
        })
      );

  // Confirm delete
  const confirmDelete = (docId: string) => {
    showModal({
      type: 'confirm',
      heading: t('healthAndSafetyTraining.confirmDeleteHeadingSingle'),
      content: t('healthAndSafetyTraining.confirmDeleteMsgSingle'),
      onConfirm: () => handleDelete(docId),
      confirmLabel: t('documents.table.confirmHardDeleteDocLabel'),
    });
  };

  const containerClass = className || 'ml-3';

  return (
    <div className={`d-inline-block ${containerClass}`}>
      <TooltipWrapper
        id="tooltip-delete"
        overlay={buttonText}
      >
        <Button
          type="button"
          btnType="danger"
          outlined
          size={size}
          disabled={disabled}
          onClick={e => {
            confirmDelete(id);
            e.stopPropagation();
          }}
        >
          <FaTrash size={14} />
        </Button>
      </TooltipWrapper>
    </div>
  );
};

export default HardDeleteDoc;
